import { SignalTree } from "../types/signal-tree.type";

export function ensureMergeImpl<T extends object>(
    node: SignalTree<T>,
    factory: () => T
): SignalTree<T> {
    node.update(v => ({...factory(), ...(v ?? {})}));

    return node;
}